import {ISplitButtonParams} from '../../button/splitButton/split-button';
import {IRouteDefinitionParams} from '../../../index';
import {global, lm} from '../../../appContext';
import {nsGroupMembers} from '../../group/members/nsGroupMembers';
import {nsFa} from '../../fa/fn';
import {MembershipList} from './membershipList';
import i = nsFa.i;
import detailsHtml from './details.html?raw';

export const template = detailsHtml;

interface IParams extends Pick<IRouteDefinitionParams, '__id' | '__routeParams' | '__componentId'> {
    /** When set, loads memberships for this user; otherwise the current route object id is used. */
    userid?: number;
}

/** Resolves the target user id from an explicit param or the active user route. */
function resolveUserId(params: IParams): number {
    if (params.userid != null) {
        const id = Number(params.userid);
        if (!Number.isNaN(id)) {
            return id;
        }
    }
    const routeId = params.__id ?? params.__routeParams?.['id'] ?? global.getRouteId();
    return Number(routeId);
}

export class viewModel {
    readonly membershipList: MembershipList;
    readonly __componentId: string;
    readonly userid: number;

    constructor(params: IParams) {
        this.userid = resolveUserId(params);
        this.__componentId = params.__componentId ?? `user-membership_${this.userid}`;
        this.membershipList = new MembershipList(this.userid);
        this.membershipList.start();
    }

    canAddMembership(): boolean {
        return global.permissionValidator.isMinCompanyAdmin();
    }

    getAddMembershipSplitButtonParams(): ISplitButtonParams | null {
        if (!this.canAddMembership() || !this.membershipList.isReady()) {
            return null;
        }
        return {
            mainButton: {
                cls: 'btn-action btn-sm',
                icon: 'fa-plus',
                label: 'user.membership.add',
                onClick: () => this.onAddMembershipClick(),
                validator: () => this.canAddMembership(),
            },
        };
    }

    onAddMembershipClick(): void {
        const userData = this.membershipList.getUserData();
        if (!userData?.id || !this.canAddMembership()) {
            return;
        }
        nsGroupMembers.showManualMembershipEducationConfirm(() => {
            global.dialogManager.addComponent({
                title: `${i('fa-plus')} ((add)) ((${lm.t('membership')}))`,
                content: {
                    name: 'component/user/membership-v2/dialog/add-groups',
                    params: {
                        user: userData,
                        excludedGroupIds: this.membershipList.getExcludedGroupIds(),
                        onComplete: () => this.membershipList.refreshAfterOverrideMutation(),
                    },
                },
            });
        });
    }

    showFuncColumn(): boolean {
        return global.permissionValidator.isMinCompanyAdmin();
    }

    dispose(): void {
        this.membershipList.dispose();
    }
}
